/**
 * Axios / fetch abort — do not toast as a failed upload.
 * @param {unknown} error
 */
export function isUploadAbortError(error) {
    const seen = [
        error,
        error?.original,
        error?.originalError,
        error?.cause,
        error?.original?.originalError,
        error?.originalError?.originalError,
    ];
    return seen.some((item) => (
        item
        && (item.code === 'ERR_CANCELED'
            || item.name === 'CanceledError'
            || item.name === 'AbortError'
            || item.message === 'canceled')
    ));
}
